"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const faArrowRight_1 = require("@fortawesome/pro-light-svg-icons/faArrowRight");
const faArrowRight_2 = require("@fortawesome/pro-regular-svg-icons/faArrowRight");
const faArrowRight_3 = require("@fortawesome/pro-solid-svg-icons/faArrowRight");
const createIcon_1 = __importDefault(require("./utils/createIcon"));
const ArrowRightIcon = (0, createIcon_1.default)({
    displayName: 'ArrowRightIcon',
    title: 'Arrow right icon',
    icon: faArrowRight_1.faArrowRight,
    variantIcons: {
        light: faArrowRight_1.faArrowRight,
        regular: faArrowRight_2.faArrowRight,
        solid: faArrowRight_3.faArrowRight,
    },
});
exports.default = ArrowRightIcon;
